import type { PartnerName } from '@jerry-serverless/analyticslib/partner';

// Partner list to show Interstitial page
export const INTERSTITIAL_ENABLED_LIST: PartnerName[] = [
  'benzinga',
  'dmv',
  'empowerdirect',
  'iseecars',
  'jobble',
  'kiplinger',
  'maxbounty',
  'mediaalpha',
  'mint',
  'moneycrashers',
  'nerdwallet',
  'nonda',
  'self',
  'stash',
  'theweek',
  'everquote',
  'smartfinancial',
  'transparently',
  'quinstreet',
  'qw',
  'gasbuddy',
  'gasbuddyapp',
  'gasbuddyemail',
  'gasbuddyalt',
  'facebook',
];

// Partner list to show Welcome-Interstitial page with prefilled name and phone number
export const WELCOME_ENABLED_LIST: PartnerName[] = [
  'edriving',
  'everquote',
  'fiona',
  'internetbrands',
  'mediaalpha',
  'ratemarketplace',
  'qw',
  'kissterra',
  'smartfinancial',
  'spotangels',
];

// Partner list to show custom landing page
export const CUSTOM_LANDING_ENABLED_LIST: PartnerName[] = ['acorns', 'fiona', 'cbautogroup'];

// Partner list to show custom messages on prefilled page('WelcomeLanding.tsx').
export const CUSTOM_PREFILLED_PAGE_PARTNER_LIST: PartnerName[] = ['qw', 'mediaalpha'];
